/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ export var TranslationKey = /*#__PURE__*/ function(TranslationKey) {
    TranslationKey["BackButton"] = "BackButton";
    TranslationKey["ConfirmNewPassword"] = "ConfirmNewPassword";
    TranslationKey["Connect"] = "Connect";
    TranslationKey["ConnectYourAccount"] = "ConnectYourAccount";
    TranslationKey["ConnectYourAccountDescription"] = "ConnectYourAccountDescription";
    TranslationKey["Continue"] = "Continue";
    TranslationKey["CreateNewPassword"] = "CreateNewPassword";
    TranslationKey["CurrentPassword"] = "CurrentPassword";
    TranslationKey["ForgotYourPassword"] = "ForgotYourPassword";
    TranslationKey["ForgotYourPasswordDescription"] = "ForgotYourPasswordDescription";
    TranslationKey["HidePassword"] = "HidePassword";
    TranslationKey["JoinUs"] = "JoinUs";
    TranslationKey["KeepMeSignIn"] = "KeepMeSignIn";
    TranslationKey["KeepMeSignInCookiesTooltip"] = "KeepMeSignInCookiesTooltip";
    TranslationKey["MemberNumberOrEmail"] = "MemberNumberOrEmail";
    TranslationKey["MobilePhone"] = "MobilePhone";
    TranslationKey["NewPassword"] = "NewPassword";
    TranslationKey["NewPasswordDescription"] = "NewPasswordDescription";
    TranslationKey["NewPasswordTitle"] = "NewPasswordTitle";
    TranslationKey["NewTemporaryPasswordDescription"] = "NewTemporaryPasswordDescription";
    TranslationKey["NewToOriflame"] = "NewToOriflame";
    TranslationKey["Password"] = "Password";
    TranslationKey["PasswordlessCancel"] = "PasswordlessCancel";
    TranslationKey["PasswordlessRegister"] = "PasswordlessRegister";
    TranslationKey["PasswordlessRegisterTitle"] = "PasswordlessRegisterTitle";
    TranslationKey["PasswordlessSignIn"] = "PasswordlessSignIn";
    TranslationKey["SelectCountry"] = "SelectCountry";
    TranslationKey["SelectCountryPlaceholder"] = "SelectCountryPlaceholder";
    TranslationKey["ShowPassword"] = "ShowPassword";
    TranslationKey["SignIn"] = "SignIn";
    TranslationKey["SignInTitle"] = "SignInTitle";
    TranslationKey["SignInWithMemberOrEmail"] = "SignInWithMemberOrEmail";
    TranslationKey["SignWithMobilePhone"] = "SignWithMobilePhone";
    TranslationKey["SignWithSocialNetwork"] = "SignWithSocialNetwork";
    TranslationKey["TemporaryPassword"] = "TemporaryPassword";
    TranslationKey["TemporaryPasswordLink"] = "TemporaryPasswordLink";
    TranslationKey["TenantSelect"] = "TenantSelect";
    TranslationKey["currentPasswordRequired"] = "currentPasswordRequired";
    TranslationKey["enterPassword"] = "enterPassword";
    TranslationKey["enterTemporaryPassword"] = "enterTemporaryPassword";
    TranslationKey["errUserLockedOut"] = "errUserLockedOut";
    TranslationKey["errUserNotAllowed"] = "errUserNotAllowed";
    TranslationKey["errUsernameOrPassword"] = "errUsernameOrPassword";
    TranslationKey["invalidLoginName"] = "invalidLoginName";
    TranslationKey["invalidLoginPhone"] = "invalidLoginPhone";
    TranslationKey["invalidNewPassword"] = "invalidNewPassword";
    TranslationKey["invalidPassword"] = "invalidPassword";
    TranslationKey["invalidToken"] = "invalidToken";
    TranslationKey["keepMeSignInTooltip"] = "keepMeSignInTooltip";
    TranslationKey["memberOrEmailTooltip"] = "memberOrEmailTooltip";
    TranslationKey["mobilePhoneTooltip"] = "mobilePhoneTooltip";
    TranslationKey["mobilePhoneTooltipPhoneWithPrefix"] = "mobilePhoneTooltipPhoneWithPrefix";
    TranslationKey["networkError"] = "networkError";
    TranslationKey["newPasswordRequired"] = "newPasswordRequired";
    TranslationKey["passwordRequired"] = "passwordRequired";
    TranslationKey["passwordRequirementCharactersCount"] = "passwordRequirementCharactersCount";
    TranslationKey["passwordRequirementDigit"] = "passwordRequirementDigit";
    TranslationKey["passwordRequirementLetter"] = "passwordRequirementLetter";
    TranslationKey["passwordRequirementLowercase"] = "passwordRequirementLowercase";
    TranslationKey["passwordRequirementSpecialCharacter"] = "passwordRequirementSpecialCharacter";
    TranslationKey["passwordRequirementUppercase"] = "passwordRequirementUppercase";
    TranslationKey["resendInMinute"] = "resendInMinute";
    TranslationKey["socialNetworkApple"] = "socialNetworkApple";
    TranslationKey["socialNetworkFacebook"] = "socialNetworkFacebook";
    TranslationKey["socialNetworkGoogle"] = "socialNetworkGoogle";
    TranslationKey["socialNetworkVKontakte"] = "socialNetworkVKontakte";
    TranslationKey["socialNetworkWeChat"] = "socialNetworkWeChat";
    TranslationKey["userNotFound"] = "userNotFound";
    TranslationKey["usernameRequired"] = "usernameRequired";
    return TranslationKey;
}({});
